import {getUsersByBrand} from "@js/api/domain/user";

document.addEventListener('DOMContentLoaded', function() {
    const $brandSelect      = $('#bulk-brand-id');
    const $userSelect       = $('#bulk-user-select');
    const $assignmentType   = $('#assignment_type');

    $brandSelect.on('change', async function () {
        const brandID = $(this).val();

        if (brandID === 'all_admin') {
            $assignmentType.val('all_admin');
            $userSelect.prop('disabled', true);
            return;
        }

        $assignmentType.val('individual');

        $userSelect.prop('disabled', true).html('<option>Loading users...</option>');

        try {
            const { data } =  await getUsersByBrand(brandID);
            populateUserDropdown(data);
        } catch (error) {
            console.error('Failed to fetch users:', error);
            $userSelect.html('<option>Error loading users</option>').prop('disabled', false);
        }
    });

    const populateUserDropdown = async (users) => {
        $userSelect.html('<option value="all">All Brand Users</option>');

        if (Array.isArray(users)) {
            const options = users
                .filter(user => user?.id != null && user?.name)
                .map(user => $('<option>', { value: user.id, text: user.name }));

            $userSelect.append(options);
        }

        $userSelect.prop('disabled', false);
    }

    // lock out the UI when updating
    $('#ff-mgmt-forms-wrap form').on('submit', function(e) {
        $('#js-submit-overlay').css('display', 'flex');

        var $currentForm = $(this);
        const $submitBtn = $currentForm.find('button[type="submit"]');

        $submitBtn.prop('disabled', true);

    });
});
